import { envManager } from "./env";

// API 配置
export const API_CONFIG = {
  // 使用 getter 延迟获取 BASE_URL，确保在 initCasa 设置 market 后能获取正确的 URL
  get BASE_URL() {
    return envManager.getApiUrl();
  },

  ENDPOINTS: {
    PROACTIVE_MESSAGE_GET: "/get-proactive-greeting",
    PROACTIVE_MESSAGE_CLICK: "/proactive",
    FAQ_RECOMMEND: "/faq/recommend",
    FAQ_SEARCH: "/faq/search",
    FAQ_DETAIL: "/faq/detail",
    LOGIN: "/optional-login",
    LOGIN_CALLBACK: "/login-callback",
    LOGOUT_CALLBACK: "/logout-callback",
    CONVERSATION_STATUS: "/conversation/status",
    CONVERSATION_INFO: "/conversation/info",
    CONVERSATION_HANDOFF_ACTION: "/conversation/handoff-action",
    CHAT_MESSAGE: "/message",
    CHAT_HISTORY: "/chat/history",
    CHAT_MODE: "/chat/mode",
    HANDOFF: "/handoff",
    MESSAGE_REVIEW: "/message/review",
    MESSAGE_REVIEW_CANCEL: "/message/review/cancel",
    CART_ADD_RECORD: "/cart-record",
    UPLOAD: "/upload",
    UPLOAD_PRESIGN: "/presign-upload-file",
    CSAT: "/csat-review",
    MESSAGE_PRODUCT_VISIT: "/visit-sku",
  },
};

// 创建完整的 API URL
export const createApiUrl = (endpoint: string): string =>
  `${API_CONFIG.BASE_URL}${endpoint}`;

export const PROACTIVE_API = {
  get: () => createApiUrl(API_CONFIG.ENDPOINTS.PROACTIVE_MESSAGE_GET),
  click: () => createApiUrl(API_CONFIG.ENDPOINTS.PROACTIVE_MESSAGE_CLICK),
};

// FAQ 搜索 API
export const FAQ_API = {
  recommend: () => createApiUrl(API_CONFIG.ENDPOINTS.FAQ_RECOMMEND),
  search: () => createApiUrl(API_CONFIG.ENDPOINTS.FAQ_SEARCH),
  detail: () => createApiUrl(API_CONFIG.ENDPOINTS.FAQ_DETAIL),
};

export const LOGIN_API = {
  login: () => createApiUrl(API_CONFIG.ENDPOINTS.LOGIN),
  loginCallback: () => createApiUrl(API_CONFIG.ENDPOINTS.LOGIN_CALLBACK),
  logoutCallback: () => createApiUrl(API_CONFIG.ENDPOINTS.LOGOUT_CALLBACK),
};

export const CONVERSATION_API = {
  status: () => createApiUrl(API_CONFIG.ENDPOINTS.CONVERSATION_STATUS),
  info: () => createApiUrl(API_CONFIG.ENDPOINTS.CONVERSATION_INFO),
  handoffAction: () =>
    createApiUrl(API_CONFIG.ENDPOINTS.CONVERSATION_HANDOFF_ACTION),
};

// Chat API
export const CHAT_API = {
  mode: () => createApiUrl(API_CONFIG.ENDPOINTS.CHAT_MODE),
  message: () => createApiUrl(API_CONFIG.ENDPOINTS.CHAT_MESSAGE),
  history: () => createApiUrl(API_CONFIG.ENDPOINTS.CHAT_HISTORY),
  handoff: () => createApiUrl(API_CONFIG.ENDPOINTS.HANDOFF),
  messageReview: () => createApiUrl(API_CONFIG.ENDPOINTS.MESSAGE_REVIEW),
  messageReviewCancel: () =>
    createApiUrl(API_CONFIG.ENDPOINTS.MESSAGE_REVIEW_CANCEL),
};

export const CARD_CART_API = {
  addRecord: () => createApiUrl(API_CONFIG.ENDPOINTS.CART_ADD_RECORD),
};

// CSAT API
export const CSAT_API = {
  submit: () => createApiUrl(API_CONFIG.ENDPOINTS.CSAT),
};

// Upload API
export const UPLOAD_API = {
  upload: () => createApiUrl(API_CONFIG.ENDPOINTS.UPLOAD),
  presign: () => createApiUrl(API_CONFIG.ENDPOINTS.UPLOAD_PRESIGN),
};

// Message API
export const MESSAGE_API = {
  productVisit: () => createApiUrl(API_CONFIG.ENDPOINTS.MESSAGE_PRODUCT_VISIT),
};